import e from"react";import{Container as a}from"./styles.js";const t=({children:t,className:r})=>e.createElement(a,{gap:4,align:"stretch",direction:"column",className:r},t);t.displayName="StepWizardPage";export{t as StepWizardPage};
//# sourceMappingURL=StepWizardPage.js.map
